import Remitent from '@/types/documents/remitent'
import { BaseService } from './../../base'
export class RemitentService extends BaseService<Remitent>() {
    static get entity (): string {
        return 'remitent'
    }
    static get responseName (): string {
        return 'remitent'
    }
}